module.exports = __webpack_public_path__ + "static/media/productio-Circle.06e3da83.png";